module.exports = __webpack_public_path__ + "static/kindergarden-7be1c4db85e169b93f935639c52a93b4.png";